import { defineMessages } from 'react-intl';

export const MESSAGES = defineMessages({
    title: {
        id: 'register.home.title',
        defaultMessage: 'Carte sanitaire du <b>Niger</b>',
    },
    cta: {
        id: 'register.home.cta',
        defaultMessage: 'Explorer les données',
    },
    texte1: {
        id: 'register.home.texte1',
        defaultMessage:
            'Le développement de cette carte sanitaire avec l’appui de PASS ENABEL, s’inscrit dans le cadre du partage des informations sanitaires aux différents utilisateurs.',
    },
    texte2: {
        id: 'register.home.texte2',
        defaultMessage:
            // eslint-disable-next-line max-len
            'Le Ministre de la Santé Publique, de la Population et des Affaires Sociales vous souhaite la bienvenue sur la carte sanitaire digitale, interactive et dynamique. Le développement de cette carte sanitaire avec l’appui de PASS ENABEL, s’inscrit dans le cadre du partage des informations sanitaires aux différents utilisateurs. Elle joue un rôle de planification et de régulation de l’offre des soins et services. Aussi, elle permet une meilleure visibilité des tendances des indicateurs et des actions de santé, l’élaboration et la mise en œuvre d’outils de communication et d’information modernes. Elle est alimentée par le DHIS 2 qui est aujourd’hui l’outil principal de la gestion des données sanitaires de routine du Niger.',
    },
    logoText: {
        id: 'register.home.logoText',
        defaultMessage:
            'Ministère de la Santé Publique de la Population et des Affaires Sociales',
    },
    footer: {
        id: 'register.home.footer',
        defaultMessage:
            'Pour plus d’information sur les licenses des données présentées, contactez',
    },
    footerLink: {
        id: 'register.home.footerLink',
        defaultMessage: 'le gestionnaire du programme',
    },
    footerTitle1: {
        id: 'register.home.footerTitle1',
        defaultMessage: 'PARTENAIRES',
    },
    footerTitle2: {
        id: 'register.home.footerTitle2',
        defaultMessage: 'PROPULSE PAR',
    },
    dhis2: {
        id: 'register.home.dhis2',
        defaultMessage: 'DHIS2 National',
    },
    sante: {
        id: 'register.home.sante',
        defaultMessage:
            'Ministère de la Santé Publique de la Population et des Affaires Sociales',
    },
});
